import * as Yup from 'yup';
import { PqrDataSfc } from '../../../../../../shared/types/modules/pqr';
import dayjs from 'dayjs';

export const initialValues: PqrDataSfc & {
    country?: string;
    location?: string;
    hasReconsideration?: boolean;
    status?: string;
    isExtension?: boolean;
    finalResponseAttached?: boolean;
} = {
    country: '',
    location: '',
    channelPresentsFailure: '',
    isGuardianship: false,
    guardianship: '',
    controlEntity: '',
    receptionInstance: '',
    receptionPoint: '',
    admission: '',
    acceptance: '',
    rectification: '',
    desistd: '',
    hasExpressComplaint: false,
    dcfScaling: false,
    hasReconsideration: false,
    status: '',
    isVirtualProduct: false,
    isExtension: false,
    marking: '',
    updateStatusPQRDate: undefined,
    answerSFCDate: undefined,
    closingDateDCF: undefined,
    customerFilingDate: undefined,
    detailProduct: '',
    finalResponseAttached: false,
    fraudType: '',
    fraudMode: '',
    claimedAmount: '',
    approvedAmount: '',
};

export const validationSchema = (
    isRectification?: boolean,
    isInFavorOf?: boolean,
    isDcf?: boolean,
    isRequiredLocation?: boolean,
    isRequiredFraudParams?: boolean,
    responseDate?: Date
) => {
    const schema: any = {
        channelPresentsFailure: Yup.string().required(
            'El canal qué presentó falla es obligatorio'
        ),
        guardianship: Yup.string().test(
            'is-numeric',
            'El campo debe ser numérico',
            (value) => (value ? /^\d+$/.test(value) : true)
        ),
        controlEntity: Yup.string().required(
            'El ente de control es obligatorio'
        ),
        receptionInstance: Yup.string().required(
            'La instancia de recepción es obligatoria'
        ),
        receptionPoint: Yup.string().required(
            'El punto de recepción es obligatorio'
        ),
        marking: Yup.string().required('La marcación es obligatoria'),
        answerSFCDate: Yup.date().test(
            'match-response-date',
            'Validar las fechas de respuesta ya que no coinciden.',
            (value) => {
                if (isDcf) return true;

                if (!value || !responseDate) return true;

                const normalizeDate = (date: Date) =>
                    dayjs(date).second(0).millisecond(0);

                return normalizeDate(value).isSame(
                    normalizeDate(responseDate as Date)
                );
            }
        ),
        closingDateDCF: Yup.date().test(
            'match-response-date',
            'La fecha debe ser superior o igual a la fecha de respuesta',
            (value) => {
                if (!value || !responseDate) return true;

                const normalizeDate = (date: Date) =>
                    dayjs(date).second(0).millisecond(0);

                return normalizeDate(value).isSameOrAfter(
                    normalizeDate(responseDate as Date)
                );
            }
        ),
    };

    if (isInFavorOf)
        schema.acceptance = Yup.string().required(
            'La aceptación es obligatoria'
        );
    if (isRectification)
        schema.rectification = Yup.string().required(
            'La rectificación es obligatoria'
        );
    if (isDcf)
        schema.admission = Yup.string().required('La admisión es obligatoria');
    if (isRequiredLocation)
        schema.location = Yup.string().required('La ubicación es obligatoria');

    if (isRequiredFraudParams) {
        schema.fraudType = Yup.string().required(
            'La tipología de fraude es obligatoria'
        );
        schema.fraudMode = Yup.string().required(
            'La modalidad de fraude es obligatoria'
        );
        schema.claimedAmount = Yup.string()
            .required('El monto reclamado es obligatorio')
            .test('is-numeric', 'El campo debe ser numérico', (value) =>
                value ? /^\d+$/.test(value) : true
            );
        schema.approvedAmount = Yup.string()
            .required('El monto reconocido es obligatorio')
            .test('is-numeric', 'El campo debe ser numérico', (value) =>
                value ? /^\d+$/.test(value) : true
            );
    }

    return Yup.object(schema);
};
